import http from '@/utils/http'

export function getSetting(){
    return http(`/basic_informations`)
}
